import api from '@/modules/api/api';
import { deviceModule } from '@/modules/device';
import { webCampaign } from '@/modules/webCampaign';

import { QueryV1PostUsers, QueryV1PostUsersParams } from './users.types';

export async function apiV1PostUsers(params: QueryV1PostUsersParams) {
  const pheonCampaign = params.pheon_campaign ?? webCampaign.getKey();

  return api.post<QueryV1PostUsers>('v1', '/users', {
    ...params,
    vendor_id: deviceModule.id,
    from_web_onboarding: true,
    ...(pheonCampaign && { pheon_campaign: pheonCampaign }),
  });
}
apiV1PostUsers.requestKey = 'v1-post-users';
